'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var range = require('@mx/util/range');
var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "stepper"
    }, [_c('button', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      class: ['stepper-minus', {
        disabled: _vm.value <= _vm.min
      }],
      on: {
        "click": _vm.onMinus
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "tel"
      },
      domProps: {
        "value": _vm.value
      },
      on: {
        "input": _vm.onInput
      }
    }), _vm._v(" "), _c('button', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      class: ['stepper-plus', {
        disabled: _vm.value >= _vm.max
      }],
      on: {
        "click": _vm.onPlus
      }
    })]);
  },
  staticRenderFns: [],
  name: 'stepper',
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    max: {
      type: Number,
      default: Number.MAX_VALUE
    },
    min: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$emit('input', this.format(this.value));
  },
  methods: {
    onPlus: function onPlus() {
      this.$emit('input', this.format(Number(this.value) + 1));
    },
    onMinus: function onMinus() {
      this.$emit('input', this.format(Number(this.value) - 1));
    },
    onInput: function onInput(event) {
      var target = event.target;
      var value = this.format(target.value);
      this.$emit('input', value);
      target.value = value + '';
    },
    format: function format(value) {
      typeof value === 'string' && (value = value.replace(/\D/g, ''));
      return value !== '' ? range.range(Number(value), [this.min, this.max]) : Number(value);
    }
  }
});

exports.default = index;
